import axios from 'axios'
import { buildApiResponse } from './api-helpers'
import fileDownload from 'js-file-download'
import aqe from '@pushly/aqe'
import { IApiCallOptions, IApiResponse } from '@pushly/aqe/lib/interfaces'
import { axiosFetch } from '@halo/_utils/axios'

export const fetchInsights = async (
    contract: any,
    opts: IApiCallOptions & {
        scopedInsightsPath?: string
    },
): Promise<IApiResponse<any[]>> => {
    const svcRes = buildApiResponse<any>({ data: [] })

    try {
        const res = await axiosFetch(
            'post',
            {
                url: opts?.scopedInsightsPath
                    ? `${aqe.defaults.publicApiDomain}/${opts.scopedInsightsPath.replace(/^\//, '')}`
                    : aqe.defaults.insightsDomain,
                data: contract,
            },
            null,
        )

        const responseIsCSV = /text\/csv/i.test(res.request.getResponseHeader('content-type'))
        if (responseIsCSV) {
            svcRes.ok = true
            fileDownload(res.data, `${contract.filename || 'pushly-insights'}.csv`)
        } else if ('report_url' in res.data) {
            const fileReq = await axios.get(res.data.report_url, {
                external: true,
            } as any)

            svcRes.ok = true
            svcRes.data = fileReq.data.data
            svcRes.meta = fileReq.data.meta
        } else {
            svcRes.ok = true
            svcRes.data = res.data.data
        }
    } catch (err) {
        svcRes.cancelled = axios.isCancel(err)
        if (!svcRes.cancelled) {
            console.warn(err)
        }
    }

    return svcRes
}
